import { DEFAULT_LIMIT } from '../SearchManager/FormData';
import {BrandAndMarketListItem} from "../../../integrated-client";

export interface IFormData {
  showNonEffective: boolean
  label: string | null
  brandAndMarket: BrandAndMarketListItem | null
  offset: number
  limit: number
  currentPage: number
}

export class FormData implements IFormData {

  showNonEffective: boolean
  label: string | null
  brandAndMarket: BrandAndMarketListItem | null
  offset: number
  limit: number
  currentPage: number

  constructor() {
    this.showNonEffective = false;
    this.label = null;
    this.brandAndMarket = null
    this.offset = 0;
    this.limit = DEFAULT_LIMIT;
    this.currentPage = 1;
  }

}
